import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageVisit } from '../lib/analytics';
import { useAnalyticsConsent } from './useAnalyticsConsent';

/**
 * Tracks a page visit per route/project change, but only while analytics consent is
 * `accepted`. Granting consent on a page tracks that page once; rejecting or withdrawing
 * stops tracking immediately (#125).
 */
export function usePageTracking(projectId?: number): void {
  const location = useLocation();
  const consent = useAnalyticsConsent();
  const allowed = consent === 'accepted';

  useEffect(() => {
    if (!allowed) return;
    trackPageVisit(location.pathname, projectId);
  }, [allowed, location.pathname, projectId]);
}
